// src/pages/App.js

import React, { useState } from "react";
import "./App.css";
import { Routes } from "../config";
import { BackendDataProvider } from "../contexts/backendDataContexts";

const App = () => {
  const [backEndData, setBackEndData] = useState();

  //user login
  const setUserDetail = (data) => {
    setBackEndData((prevState) => ({
      ...prevState,
      userData: data,
    }));
  };

  const getUserDetails = () => {
    return backEndData?.userData;
  };

  return (
    <>
      <BackendDataProvider
        value={{
          data: backEndData,
          setUserDetail: setUserDetail,
          getUserDetails: getUserDetails,
        }}
      >
        <Routes />
      </BackendDataProvider>
    </>
  );
};

export default App;
